// Central source of truth for the native Pickify apps.
// Update here and every CTA across the site picks it up.

export const APP_STORE = {
  ios: {
    appId: '6760367746',
    bundleId: 'com.pickify.app',
    url: 'https://apps.apple.com/app/id6760367746',
    deepLink: 'pickify://home',
  },
  android: {
    bundleId: 'com.pickifyai.app',
    url: 'https://play.google.com/store/apps/details?id=com.pickifyai.app',
  },
  meta: {
    rating: 4.8,
    ratingCount: '12,000+',
    tagline: 'AI Gift Finder',
    valueProps: [
      'Save your gift picks',
      'Get deal alerts before prices rise',
      'Faster re-quizzes on the go',
    ],
  },
};

export const getStoreUrl = (platform, source) => {
  const base = platform === 'ios' ? APP_STORE.ios.url : APP_STORE.android.url;
  const params = new URLSearchParams();
  if (source) {
    if (platform === 'ios') {
      params.set('ct', source);
      params.set('pt', 'pickify-web');
    } else {
      params.set('referrer', `utm_source=pickify-web&utm_medium=cta&utm_campaign=${source}`);
    }
  }
  const qs = params.toString();
  return qs ? `${base}${base.includes('?') ? '&' : '?'}${qs}` : base;
};
